import React from 'react';
import { graphql } from 'gatsby';
import * as PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

// import Button from '$landing-page-raika/components/button';
// import PageSection from '$landing-page-raika/components/page-section';
// import SkewBackground from '$landing-page-raika/components/skew-background';
import NarrowHeaderWithImageLayout from '$landing-page-raika/layouts/narrow-header-with-image-layout';

import useStyles from './styles';

export const pageQuery = graphql`
    query solutionPage($path: String!) {
        markdownRemark(frontmatter: { path: { eq: $path } }) {
            html
            frontmatter {
                path
                title
                image {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED, height: 100, quality: 100, placeholder: NONE)
                    }
                }
                sampleStudiesBackground {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED, width: 800, quality: 100, placeholder: NONE)
                    }
                }
                sampleStudies {
                    title
                    url
                }
            }
        }
        pattern: file(relativePath: { eq: "page-solution-pattern.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, width: 1920, quality: 100, placeholder: NONE)
            }
        }
    }
`;

const SolutionPage = (props) => {
    const { location, data } = props;
    const entry = data.markdownRemark;
    const classes = useStyles();
    return (
        <NarrowHeaderWithImageLayout
            pathname={location.pathname}
            title={entry.frontmatter.title}
            backgroundImage={data.pattern}
            image={entry.frontmatter.image}
            // outOfPageContent={
            //     <SkewBackground rootClassName={classes.sectionTwoRoot} skewBackgroundClassName={classes.sectionTwoSkewBackground}>
            //         <PageSection>
            //             <Typography variant="h3" color="primary" align="center">
            //                 Sample Studies with Ebn-E-Sina Research
            //             </Typography>
            //             <br />
            //             <br />
            //             {entry.frontmatter.sampleStudies.map((sampleStudy, sampleStudyIndex) => (
            //                 // eslint-disable-next-line react/no-array-index-key
            //                 <Box component="div" key={`sample_study_${sampleStudyIndex}`}>
            //                     <Grid container justify="center">
            //                         <Grid item xs={12} sm={10} md={7} lg={5}>
            //                             <Button
            //                                 component="a"
            //                                 href={sampleStudy.url}
            //                                 variant="contained"
            //                                 color="logo-yellow"
            //                                 fullWidth
            //                             >
            //                                 {sampleStudy.title}
            //                             </Button>
            //                         </Grid>
            //                     </Grid>
            //                     <br />
            //                 </Box>
            //             ))}
            //         </PageSection>
            //     </SkewBackground>
            // }
        >
            <Box dangerouslySetInnerHTML={{ __html: entry.html }} className={classes.contentWrapper} />
        </NarrowHeaderWithImageLayout>
    );
};

SolutionPage.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    data: PropTypes.shape({
        markdownRemark: PropTypes.shape({
            frontmatter: PropTypes.shape({
                title: PropTypes.string,
                sampleStudies: PropTypes.oneOfType([PropTypes.array]),
                image: PropTypes.oneOfType([PropTypes.object]),
            }),
            html: PropTypes.string,
        }),
        pattern: PropTypes.oneOfType([PropTypes.object]),
    }).isRequired,
};

export default SolutionPage;
